<app-page-shell variant="default">
<div class="card card-box package-list mb-5">
      <div class="card-header py-3">
        <div class="card-header--title font-size-lg">
          Manage Packages
        </div>
        <div class="card-header--actions">
          <a class="btn btn-sm btn-primary" [routerLink]="['add']" sbEntityLink role="button">
            <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
            <span class="btn-wrapper--label">Add New Package</span>
          </a>
        </div>
      </div>
      <div class="p-3">
        <app-sb-table
          [rows]="packages()"
          [totalRows]="totalPackages()"
          [columns]="tableColumns"
          [options]="tableOptions"
          (stateChange)="onTableState($event)">

          <ng-template sbTableCell="name" let-pkg>{{pkg.name}}</ng-template>
          <ng-template sbTableCell="project_count_limit" let-pkg>{{pkg.project_count_limit}}</ng-template>
          <ng-template sbTableCell="project_campaign_count_limit" let-pkg>{{pkg.project_campaign_count_limit}}</ng-template>
          <ng-template sbTableCell="project_influencer_count_limit" let-pkg>{{pkg.project_influencer_count_limit}}</ng-template>

          <ng-template sbTableActions let-pkg>
            <button class="btn-icon float-end" mat-icon-button [matMenuTriggerFor]="menu"
                    aria-label="Example icon-button with a menu">
              <span class="fa fa-ellipsis-v"></span>
            </button>
            <mat-menu #menu="matMenu" class="campaign-popover">
              <a class="dropdown-item" [routerLink]="['edit', pkg.id]" sbEntityLink>
                <i class="fa fa-pencil me-2"></i>Edit</a>
              <a class="dropdown-item" (click)="deletePackage(pkg.id)">
                <i class="fa fa-trash me-2"></i>Delete</a>
            </mat-menu>
          </ng-template>
        </app-sb-table>
      </div>
    </div>
</app-page-shell>
